export const SPEND_TAGS = {
  SUPPLIERS: "SpendSuppliers",
  SETTINGS: "SpendSettings",
  OWNERS: "SpendOwners",
  FAMILIES: "SpendFamilies",
  SERIES: "SpendSeries",
  REPORTS: "SpendReports",
} as const;

export const SPEND_PAGE_SIZE = 25;
export const SPEND_FAMILY_PAGE_SIZE = 100;
